<template>
    <div :class="['btn button-priority-wrap', classes.backgroundWrapFocus]" @click="$emit('select', priority)">
        <div :class="['align-c button-priority single', classes.backgroundType]">
            <p class="name" v-html="Name(priority.Name)"></p>
            <img class="icon" :src="iconSource" alt="Icon - Project Type - Social Impact" title="Social Impact" width="90" height="90"/>
        </div>
        <PriorityTypeDateRange :priority="priority" :showPriorityTypeLabel="true"/>
    </div>
</template>

<script>
import { ASSETS } from "@/assets/JS/Assets.js";
import PriorityTypeDateRange from "@/components/PriorityTypeDateRange.vue";

export default {
    name: "PriorityTypeButton",
    props: { priority: Object },
    components: { PriorityTypeDateRange },
    data: () => ({
        classes: {
            backgroundWrapFocus: "",
            backgroundType: ""
        },
        iconSource: "",
        ASSETS
    }),
    methods: {
        Name: function(name) { return name.replace(" ", "<br/>"); }
    },
    beforeMount: function() {
        const backgroundFocus = ASSETS.PriorityType.Focused(this)
            ? "button-priority-focus"
            : "";
        const backgroundSecondary = !ASSETS.PriorityType.Focused(this)
            ? "button-priority-secondary"
            : "";
        this.classes = {
            backgroundType: `${backgroundFocus} ${backgroundSecondary}`,
            backgroundWrapFocus: ASSETS.PriorityType.Focused(this)
            ? "button-priority-wrap-focus"
            : ""
        };
        this.iconSource = require(`@/assets/Images/${this.priority.IconSource}`);
    },
    emits: [ "select" ]
};
</script>